import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { api } from "../lib/api";

export function useModules() {
  const [mods, setMods] = useState(() => { try { return JSON.parse(localStorage.getItem("athanor-modules")) || null; } catch { return null; } });
  useEffect(() => { api.get("/settings").then(({ data }) => setMods(data.modules || { sales: true, marketing: true, secretary: true })).catch(() => {}); }, []);
  return mods;
}

export function PlanLocked({ feature = "Questa funzione" }) {
  return (
    <div className="athanor-card mx-auto mt-10 max-w-lg p-8 text-center" data-testid="plan-locked">
      <Lock className="mx-auto h-8 w-8 text-[#C5A059]" />
      <h2 className="mt-3 text-lg font-semibold text-slate-100">Disponibile nel piano Ufficio completo</h2>
      <p className="mt-2 text-sm text-slate-400">{feature} non è inclusa nel tuo piano. Con Ufficio completo (€149/mese) Athanor legge ogni campagna, gruppo e inserzione fino al contratto, con avvisi marketing e ClickUp.</p>
      <Link to="/impostazioni?s=plan" data-testid="plan-locked-upgrade" className="mt-5 inline-block rounded-md bg-[#C5A059] px-4 py-2 text-sm font-semibold text-black">Vedi Piano & fatturazione</Link>
    </div>
  );
}

/** Blocca un'intera pagina se il modulo è spento (indirizzo diretto). */
export default function RequireModule({ module = "marketing", feature, children }) {
  const mods = useModules();
  if (!mods) return null;
  if (mods[module] === false) return <PlanLocked feature={feature} />;
  return children;
}
